var _defs, _rect, _path, _path2, _path3, _polygon, _path4, _circle, _path5, _path6, _path7, _rect2, _rect3, _path8, _path9, _path0, _path1, _line, _line2, _line3, _line4, _path10, _line5, _line6, _line7, _line8, _rect4, _rect5, _polygon2, _path11, _line9, _rect6, _circle2, _line0, _path12, _path13, _rect7, _rect8, _rect9, _circle3, _rect0, _rect1, _circle4, _circle5, _circle6, _circle7, _path14, _rect10, _rect11, _rect12, _rect13, _ellipse, _line1, _line10, _line11, _line12, _line13, _rect14, _rect15, _rect16, _polygon3, _rect17, _path15, _path16, _rect18, _rect19, _rect20, _circle8, _line14, _path17, _line15, _line16, _line17, _line18, _rect21, _path18, _polygon4, _polygon5, _rect22, _polygon6, _path19, _polygon7, _rect23, _line19, _line20, _line21, _line22, _rect24, _path20, _circle9, _rect25, _rect26, _rect27, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect28, _rect29, _rect30, _line23, _line24, _line25, _line26, _line27, _rect31, _line28, _line29, _line30, _line31, _line32, _rect32, _line33, _line34, _line35, _line36, _line37, _rect33, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _rect34, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _line77, _rect63, _rect64, _rect65, _rect66, _polygon8, _polyline, _path33, _path34, _path35, _rect67, _rect68, _circle0, _circle1, _circle10, _circle11, _rect69, _rect70, _polygon9, _rect71, _polygon0, _rect72, _rect73, _rect74, _rect75, _rect76, _ellipse2, _path36, _path37, _polyline2, _polyline3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalfunctionsKaplanVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 918 612",
    width: 918,
    height: 612,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .malfunction {\n        cursor: pointer;\n      }\n\n      .group {\n        cursor: pointer;\n      }\n\n      .cls-1, .cls-16, .cls-2 {\n        fill: #ddd;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-18, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-9 {\n        stroke: #202020;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-3 {\n        fill: #6f6f6f;\n      }\n\n      .cls-4 {\n        fill: #f6f6f6;\n      }\n\n      .cls-15, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #ededed;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13, .cls-17, .cls-19, .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-7 {\n        stroke: #ddd;\n      }\n\n      .cls-8 {\n        stroke: #6f6f6f;\n      }\n\n      .cls-14, .cls-9 {\n        fill: #9c9c9c;\n      }\n\n      .cls-11 {\n        stroke-linecap: round;\n      }\n\n      .cls-12 {\n        stroke-dasharray: 2.08 2.08 2.08 2.08;\n      }\n\n      .cls-13 {\n        stroke-dasharray: 2.08 2.08 2.08 2.08 2.08 2.08;\n      }\n\n      .cls-14, .cls-15, .cls-16 {\n        stroke-linejoin: bevel;\n      }\n\n      .cls-17 {\n        stroke: #ededed;\n      }\n\n      .cls-18 {\n        fill: #202020;\n      }\n\n      .cls-19 {\n        stroke: #9c9c9c;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 142.46,
    width: 42.82,
    height: 209.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,351.52H42.4V314.21h74l40.32,29.84L178.8,360.5l90.57,67a46,46,0,0,0,27.42,9.05H811.6v-85H314.45l-44.37-31.74-22.78-16.3h0L135.16,223.29a46.06,46.06,0,0,0-26.82-8.6h-66V142.46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M632.2,428.4l.63-11.7c0-2.84-2.3-5.53-5.13-5.53H593.85v-30L790,381.3v30H755.55a5.38,5.38,0,0,0-5.13,5.42l.56,10.46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M750.22,419,764,515.51H619.37L633.1,419Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "713.13 448.91 699.23 479.46 683.25 479.46 669.82 448.91 669.16 440.45 714.09 440.45 713.13 448.91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M632.2,428.4l.63-11.7c0-2.84-2.3-5.53-5.13-5.53H593.85v-30L790,381.3v30H755.55a5.38,5.38,0,0,0-5.13,5.42l.56,10.46"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 366.58,
    cy: 144.63,
    r: 17.87
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M679.56,306H325.1a2.41,2.41,0,0,1-2.41-2.41h0V281.06a2.41,2.41,0,0,1,2.41-2.41h129a2.41,2.41,0,0,0,2.41-2.41h0v-9.35a2.41,2.41,0,0,0-2.41-2.41H258.59a2.41,2.41,0,0,1-2.41-2.41h0v-7.52a2.41,2.41,0,0,1,2.41-2.41h94.66a2.41,2.41,0,0,0,2.41-2.41h0V211.8a2.41,2.41,0,0,0-2.41-2.41H308.78a2.41,2.41,0,0,1-2.41-2.41h0V172a2.41,2.41,0,0,0-2.41-2.41H276.14a2.39,2.39,0,0,1-2.41-2.37h0V145.75a2.39,2.39,0,0,1,2.37-2.41h47.11a2.41,2.41,0,0,0,2.41-2.41h0v-4.52A2.41,2.41,0,0,1,328,134h41.69a2.41,2.41,0,0,1,2.41,2.41h0v2.49a2.41,2.41,0,0,1-2.41,2.41H364a2.39,2.39,0,0,0-2.41,2.37h0v1.85a2.41,2.41,0,0,0,2.41,2.41h5.76a2.41,2.41,0,0,1,2.41,2.41h0v2.51a2.41,2.41,0,0,1-2.41,2.41h-34.4a2.39,2.39,0,0,0-2.41,2.37h0v9.5a2.39,2.39,0,0,0,2.37,2.41H466.16a2.39,2.39,0,0,0,2.41-2.37h0V150.4A2.41,2.41,0,0,1,471,148h.8a2.41,2.41,0,0,1,2.41,2.41h0v23.14a2.41,2.41,0,0,1-2.41,2.41h-51a2.41,2.41,0,0,0-2.41,2.41h0v135.5a2.41,2.41,0,0,0,2.41,2.41H679.56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M630.6,327.63H750.83a2.39,2.39,0,0,1,2.41,2.37h0v49.14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M620.1,285.93h8.09a2.41,2.41,0,0,1,2.41,2.41v90.8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 656.33,
    y: 278.65,
    width: 19.31,
    height: 5.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 679.56,
    y: 275.06,
    width: 23.6,
    height: 129.89
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M619.37,515.51a95.8,95.8,0,0,0,20.18,59.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M764,515.51a8.61,8.61,0,0,0,10,6.88"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M511.76,231.82h1.61a5.77,5.77,0,0,1,5.77,5.77h0v47.57a2.82,2.82,0,0,1-2.82,2.82h-7.51a2.82,2.82,0,0,1-2.82-2.82h0V237.58A5.78,5.78,0,0,1,511.76,231.82Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M547,235.23h0a7.44,7.44,0,0,1,7.44,7.44h0V257a7.44,7.44,0,0,1-7.44,7.44h0a7.44,7.44,0,0,1-7.43-7.44V242.67A7.44,7.44,0,0,1,547,235.23Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 542.79,
    y1: 247.1,
    x2: 542.79,
    y2: 258.84
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 545.63,
    y1: 247.78,
    x2: 545.63,
    y2: 259.52
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 548.46,
    y1: 247.78,
    x2: 548.46,
    y2: 259.52
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 551.3,
    y1: 247.1,
    x2: 551.3,
    y2: 258.84
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M566.71,235.23h0a7.44,7.44,0,0,1,7.43,7.44V257a7.44,7.44,0,0,1-7.43,7.44h0a7.44,7.44,0,0,1-7.44-7.44h0V242.67a7.44,7.44,0,0,1,7.44-7.44Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 562.45,
    y1: 247.1,
    x2: 562.45,
    y2: 258.84
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 565.29,
    y1: 247.78,
    x2: 565.29,
    y2: 259.52
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 568.12,
    y1: 247.78,
    x2: 568.12,
    y2: 259.52
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 570.95,
    y1: 247.1,
    x2: 570.95,
    y2: 258.84
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 520.37,
    y: 258.93,
    width: 105.73,
    height: 31.67
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 520.37,
    y: 216.19,
    width: 13.52,
    height: 22.9
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "520.37 230.76 512.57 283.45 520.37 283.45 520.37 230.76"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.57,222.26h0a2.41,2.41,0,0,1,2.4,2.41v4.74a2.41,2.41,0,0,1-2.4,2.41h0a2.41,2.41,0,0,1-2.41-2.41h0v-4.74a2.41,2.41,0,0,1,2.41-2.41Z"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 527.13,
    y1: 264.48,
    x2: 527.13,
    y2: 285.93
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 599.48,
    y: 249.05,
    width: 1.37,
    height: 9.79
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 600.47,
    cy: 245.63,
    r: 4.23
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 599.19,
    y1: 246.44,
    x2: 600.47,
    y2: 245.63
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M530.22,239.26a3.12,3.12,0,1,1-6.18,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M527.13,242.81v6.65a5.74,5.74,0,0,0,5.73,5.75h0a5.73,5.73,0,0,0,3.61-1.28l3.12-2.53"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 587.97,
    y: 244.73,
    width: 2.82,
    height: 7.41
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 584.28,
    y: 241.4,
    width: 7.37,
    height: 4.59,
    rx: 2.29
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 613.56,
    y: 253.65,
    width: 7.74,
    height: 5.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 617.42,
    cy: 249.02,
    r: 6.42
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 520.37,
    y: 290.71,
    width: 7.18,
    height: 4.52
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 618.92,
    y: 290.71,
    width: 7.18,
    height: 4.52
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 543.9,
    cy: 275.11,
    r: 6.03
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 565.87,
    cy: 275.11,
    r: 6.03
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 587.84,
    cy: 275.11,
    r: 6.03
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 609.8,
    cy: 275.11,
    r: 6.03
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M583.43,243.69h0a4.83,4.83,0,0,0-4.83,4.83h0v9.76"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 582.47,
    y: 253.32,
    width: 25.4,
    height: 5.53
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 660.97,
    y: 265.74,
    width: 60.79,
    height: 9.33
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 707.11,
    y: 278.65,
    width: 19.31,
    height: 5.74
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 664.54,
    y: 256.41,
    width: 53.63,
    height: 9.33
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 584.94,
    cy: 394.01,
    rx: 30.5,
    ry: 30.6
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 42.82,
    y1: 314.27,
    x2: 42.82,
    y2: 313.27
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 42.82,
    y1: 311.19,
    x2: 42.82,
    y2: 303.93
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 42.82,
    y1: 302.89,
    x2: 42.82,
    y2: 216.72
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 42.82,
    y1: 215.69,
    x2: 42.82,
    y2: 214.69
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 42.82,
    y1: 142.37,
    y2: 142.37
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 455.75,
    y: 228.52,
    width: 2.82,
    height: 25
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 454.89,
    y: 225.19,
    width: 14.25,
    height: 4.59,
    rx: 2.29
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 367.25,
    y: 251.81,
    width: 103.44,
    height: 39.4,
    rx: 17.45
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "405.39 247.62 388.08 247.62 388.92 243.34 404.55 243.34 405.39 247.62"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 386.56,
    y: 248.06,
    width: 42.84,
    height: 3.74
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M434.05,251.71a3.12,3.12,0,1,1,6.19-.79h0a3.48,3.48,0,0,1,0,.79Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M437.14,245.48h3.95a2.54,2.54,0,0,0,2.54-2.54h0v-3.2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.49,
    y: 291.31,
    width: 7.18,
    height: 4.52
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 447.28,
    y: 291.31,
    width: 7.18,
    height: 4.52
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 446.28,
    y: 241.55,
    width: 1.37,
    height: 9.79
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 447.28,
    cy: 238.11,
    r: 4.23
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 446,
    y1: 238.93,
    x2: 447.28,
    y2: 238.11
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.82,235.49h0a7.44,7.44,0,0,1,7.44-7.43h24.1a7.44,7.44,0,0,1,7.44,7.43h0a7.44,7.44,0,0,1-7.44,7.44h-24.1a7.44,7.44,0,0,1-7.44-7.44Z"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 386.56,
    y1: 239.74,
    x2: 409.07,
    y2: 239.74
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 387.47,
    y1: 236.9,
    x2: 410.36,
    y2: 236.9
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 387.47,
    y1: 234.07,
    x2: 410.36,
    y2: 234.07
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 386.56,
    y1: 231.24,
    x2: 409.07,
    y2: 231.24
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 373.69,
    y: 225.85,
    width: 10.76,
    height: 19.27,
    rx: 3.81
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M407.46,206.76h20.13a1.74,1.74,0,0,1,1.74,1.74h0a1.74,1.74,0,0,1-1.74,1.74H407.46v-3.48Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "425.43 226.31 411.36 226.31 410.36 213.72 426.43 213.72 425.43 226.31"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "411.36 206.18 425.43 206.18 426.43 213.31 410.36 213.31 411.36 206.18"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 403.59,
    y: 203.95,
    width: 4.59,
    height: 9.76,
    rx: 2.29
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "428.65 248.06 408.14 248.06 409.14 225.79 427.65 225.79 428.65 248.06"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M429.33,208.5h5.28a2.54,2.54,0,0,1,2.53,2.54v40.77"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "484.19 160.21 457.37 160.21 458.68 153.57 482.88 153.57 484.19 160.21"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 438.37,
    y: 129.88,
    width: 60.4,
    height: 23.05,
    rx: 11.52
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 455.02,
    y1: 147.99,
    x2: 489.9,
    y2: 147.99
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 456.42,
    y1: 143.6,
    x2: 491.9,
    y2: 143.6
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 456.42,
    y1: 139.21,
    x2: 491.9,
    y2: 139.21
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 455.02,
    y1: 134.81,
    x2: 489.9,
    y2: 134.81
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 435.07,
    y: 126.47,
    width: 16.68,
    height: 29.86,
    rx: 5.9
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M352,134h17.69a2.41,2.41,0,0,1,2.41,2.41h0v2.49a2.41,2.41,0,0,1-2.41,2.41h-5.76a2.39,2.39,0,0,0-2.41,2.37h0v1.85a2.41,2.41,0,0,0,2.41,2.41h5.76a2.41,2.41,0,0,1,2.41,2.41h0v2.51a2.41,2.41,0,0,1-2.41,2.41H352.51"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 366.58,
    cy: 144.63,
    r: 17.87
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 674.07,
    y: 404.68,
    width: 35.07,
    height: 6.95
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 663.84,
    y: 356.53,
    width: 7.15,
    height: 20
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 674.55,
    y: 356.53,
    width: 33.61,
    height: 20
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M667.24,423.11A105.41,105.41,0,0,0,677.87,426a8.05,8.05,0,0,1,2.48,1.68,4.73,4.73,0,0,0,2.1,1l27,5.43a4.14,4.14,0,0,0,2.6-.12,8.85,8.85,0,0,1,3.31-.26l3.1.62c3.13.69,10.19,1.73,10.19,1.73-3.89-2.22-30.23-7.75-30.23-7.75-4.36-.46-30.12-6-32.43-6.82,0,0-1.55-.61-1.51-1.17-.42,1.61,2.71,2.83,2.71,2.83"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M713.94,440.45s1.45-11.32,1.45-15.4a85.62,85.62,0,0,0-1.11-10.74c-.18-.84-.34-1.86-.34-1.86v-.82H669v.82s-.15,1-.33,1.86a84.89,84.89,0,0,0-1.12,10.74c0,4.08,1.45,15.4,1.45,15.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M717.37,436.2c-3,0-5.41-4.07-5.41-9.08s2.42-9.09,5.41-9.09Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M715.8,427.12s.11-4-4.81-6.67c0,0-3.1-1.27-3.1-4s5.85-2.78,9.62-2.64c4.54.17,27.5,2,31.58,8.34,1.14,1.76.75,4.16.75,5.56a7,7,0,0,1-1.62,4.45c-1.56,1.85-5,3.21-11.23,4.79a201.34,201.34,0,0,1-21.19,4.35l-1.61-8.7A13.66,13.66,0,0,0,715.8,427.12Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M665.64,437.31c3,0,5.41-4.07,5.41-9.08s-2.43-9.09-5.41-9.09Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M667.13,428.23c.3,7.63,7.06,14.65,7.06,14.65l-20.77-5C642,435.18,637,433,634.79,431.09c-1.44-1.26-1.68-3.92-1.68-3.92,0-1.42.15-4.47,1.19-5.56,7.08-7.4,34.65-7.7,34.65-7.7V419A24.8,24.8,0,0,0,667.13,428.23Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M633.11,430.18a7.41,7.41,0,0,0,1.45,4.15c2.16,3,12.67,4.81,20.08,6.12,7,1.24,19.55,2.43,19.55,2.43l-20.77-5C642,435.17,637,433,634.79,431.07c-1.44-1.25-1.68-3.92-1.68-3.92Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M682.54,427.3a8.87,8.87,0,1,1,8.86,8.87A8.87,8.87,0,0,1,682.54,427.3Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M683.27,413.41s-12.9,1-18.4,6.11c0,0-1.3,1.07,1.14,1.91s28.1,6.34,32.46,6.8C698.47,428.23,691.06,424.79,683.27,413.41Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M685,426.85a48.28,48.28,0,0,0,23.06,14.44,23.57,23.57,0,0,0,20.39-3.21s1.75-1.53-.23-2.29l-8.1-2L696,429Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M682.45,428.62a4.73,4.73,0,0,1-2.1-1,8.05,8.05,0,0,0-2.48-1.68,105.41,105.41,0,0,1-10.63-2.84s-3.13-1.22-2.71-2.83c0,.56,1.51,1.17,1.51,1.17,2.31.79,28.07,6.36,32.43,6.82,0,0,26.34,5.53,30.23,7.75,0,0-7.06-1-10.19-1.73l-3.1-.62a8.85,8.85,0,0,0-3.31.26,4.14,4.14,0,0,1-2.6.12Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M702.36,58.6h48A2.41,2.41,0,0,1,752.81,61V79.53a2.41,2.41,0,0,1-2.41,2.41H729.77a2.41,2.41,0,0,0-2.41,2.41v4a2.41,2.41,0,0,0,2.41,2.41H750.4a2.41,2.41,0,0,1,2.41,2.41h0v95a2.41,2.41,0,0,1-2.4,2.42H727.16a2.43,2.43,0,0,0-2.42,2.41v14a3.21,3.21,0,0,1-3.19,3.19H717.4a2.41,2.41,0,0,0-2.4,2.41h0v35.51a2.41,2.41,0,0,0,2.41,2.41h42.74a2.42,2.42,0,0,1,2.42,2.42V288.3a2.41,2.41,0,0,1-2.41,2.41H717.4a2.41,2.41,0,0,0-2.41,2.41h0v.47a2.39,2.39,0,0,0,2.4,2.4h7.25a2.42,2.42,0,0,1,2.42,2.42h0a2.41,2.41,0,0,1-2.41,2.41H717.4a2.41,2.41,0,0,0-2.41,2.41h0v2.91a2.41,2.41,0,0,0,2.4,2.42h12.08a2.41,2.41,0,0,1,2.42,2.4h0v49.4a2.42,2.42,0,0,1-2.42,2.42h-3.63a2.43,2.43,0,0,0-2.42,2.41v6.53a2.28,2.28,0,0,1-2.28,2.28H718.9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 711.75,
    y: 356.53,
    width: 7.15,
    height: 20
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 756.24,
    y: 223.23,
    width: 22.35,
    height: 79.04
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 778.59,
    y: 223.23,
    width: 22.35,
    height: 79.04
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 783.33,
    y1: 236.68,
    x2: 796.21,
    y2: 236.68
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 783.33,
    y1: 241.02,
    x2: 796.21,
    y2: 241.02
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 783.33,
    y1: 245.37,
    x2: 796.21,
    y2: 245.37
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 783.33,
    y1: 249.71,
    x2: 796.21,
    y2: 249.71
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 778.59,
    y1: 262.75,
    x2: 800.95,
    y2: 262.75
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 800.95,
    y: 223.23,
    width: 22.35,
    height: 79.04
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 805.68,
    y1: 236.68,
    x2: 818.56,
    y2: 236.68
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 805.68,
    y1: 241.02,
    x2: 818.56,
    y2: 241.02
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 805.68,
    y1: 245.37,
    x2: 818.56,
    y2: 245.37
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 805.68,
    y1: 249.71,
    x2: 818.56,
    y2: 249.71
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 800.95,
    y1: 262.75,
    x2: 823.3,
    y2: 262.75
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 823.3,
    y: 223.23,
    width: 22.35,
    height: 79.04
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 828.03,
    y1: 236.68,
    x2: 840.91,
    y2: 236.68
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 828.03,
    y1: 241.02,
    x2: 840.91,
    y2: 241.02
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 828.03,
    y1: 245.37,
    x2: 840.91,
    y2: 245.37
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 828.03,
    y1: 249.71,
    x2: 840.91,
    y2: 249.71
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 823.3,
    y1: 262.75,
    x2: 845.65,
    y2: 262.75
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 845.65,
    y: 223.23,
    width: 22.35,
    height: 79.04
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 850.38,
    y1: 236.68,
    x2: 863.26,
    y2: 236.68
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 850.38,
    y1: 241.02,
    x2: 863.26,
    y2: 241.02
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 850.38,
    y1: 245.37,
    x2: 863.26,
    y2: 245.37
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 850.38,
    y1: 249.71,
    x2: 863.26,
    y2: 249.71
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 783.33,
    y1: 275.7,
    x2: 796.21,
    y2: 275.7
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 783.33,
    y1: 280.05,
    x2: 796.21,
    y2: 280.05
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 783.33,
    y1: 284.4,
    x2: 796.21,
    y2: 284.4
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 783.33,
    y1: 288.74,
    x2: 796.21,
    y2: 288.74
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 760.98,
    y1: 236.68,
    x2: 773.86,
    y2: 236.68
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 760.98,
    y1: 241.02,
    x2: 773.86,
    y2: 241.02
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 760.98,
    y1: 245.37,
    x2: 773.86,
    y2: 245.37
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 760.98,
    y1: 249.71,
    x2: 773.86,
    y2: 249.71
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 756.24,
    y1: 262.75,
    x2: 778.59,
    y2: 262.75
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 760.98,
    y1: 275.7,
    x2: 773.86,
    y2: 275.7
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 760.98,
    y1: 280.05,
    x2: 773.86,
    y2: 280.05
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 760.98,
    y1: 284.4,
    x2: 773.86,
    y2: 284.4
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 760.98,
    y1: 288.74,
    x2: 773.86,
    y2: 288.74
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 805.68,
    y1: 275.7,
    x2: 818.56,
    y2: 275.7
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 805.68,
    y1: 280.05,
    x2: 818.56,
    y2: 280.05
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 805.68,
    y1: 284.4,
    x2: 818.56,
    y2: 284.4
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 805.68,
    y1: 288.74,
    x2: 818.56,
    y2: 288.74
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 828.03,
    y1: 275.7,
    x2: 840.91,
    y2: 275.7
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 828.03,
    y1: 280.05,
    x2: 840.91,
    y2: 280.05
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 828.03,
    y1: 284.4,
    x2: 840.91,
    y2: 284.4
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 828.03,
    y1: 288.74,
    x2: 840.91,
    y2: 288.74
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 850.38,
    y1: 275.7,
    x2: 863.26,
    y2: 275.7
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 850.38,
    y1: 280.05,
    x2: 863.26,
    y2: 280.05
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 850.38,
    y1: 284.4,
    x2: 863.26,
    y2: 284.4
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 850.38,
    y1: 288.74,
    x2: 863.26,
    y2: 288.74
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 845.65,
    y1: 262.75,
    x2: 868,
    y2: 262.75
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 868,
    y: 223.23,
    width: 22.35,
    height: 79.04
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 872.73,
    y1: 236.68,
    x2: 885.61,
    y2: 236.68
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 872.73,
    y1: 241.02,
    x2: 885.61,
    y2: 241.02
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 872.73,
    y1: 245.37,
    x2: 885.61,
    y2: 245.37
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 872.73,
    y1: 249.71,
    x2: 885.61,
    y2: 249.71
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 872.73,
    y1: 275.7,
    x2: 885.61,
    y2: 275.7
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 872.73,
    y1: 280.05,
    x2: 885.61,
    y2: 280.05
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 872.73,
    y1: 284.4,
    x2: 885.61,
    y2: 284.4
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 872.73,
    y1: 288.74,
    x2: 885.61,
    y2: 288.74
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 868,
    y1: 262.75,
    x2: 890.35,
    y2: 262.75
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 679.56,
    y: 202.6,
    width: 23.6,
    height: 53.81
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 664.54,
    y: 71.79,
    width: 53.63,
    height: 25.83
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 653.83,
    y: 76.82,
    width: 7.15,
    height: 20.09
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 721.77,
    y: 76.82,
    width: 7.15,
    height: 20.09
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 653.83,
    y: 182.5,
    width: 7.15,
    height: 20.09
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 721.77,
    y: 182.5,
    width: 7.15,
    height: 20.09
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 65.33,
    width: 37.9,
    height: 6.46
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 674.55,
    y: 97.62,
    width: 33.61,
    height: 8.01
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 674.55,
    y: 176.05,
    width: 33.61,
    height: 6.46
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 664.54,
    y: 182.5,
    width: 53.63,
    height: 20.09
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 559.35,
    y: 105.63,
    width: 265.14,
    height: 70.42
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 564.75,
    y: 112.97,
    width: 4.7,
    height: 55.59
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 573.64,
    y: 112.97,
    width: 7.24,
    height: 55.59
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 585.05,
    y: 112.97,
    width: 9.77,
    height: 55.59
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 599,
    y: 112.97,
    width: 12.3,
    height: 55.59
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 615.49,
    y: 112.97,
    width: 14.84,
    height: 55.59
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 634.51,
    y: 112.97,
    width: 17.37,
    height: 55.59
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 656.06,
    y: 112.97,
    width: 19.9,
    height: 55.59
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 680.15,
    y: 112.97,
    width: 22.44,
    height: 55.59
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 752.72,
    y: 112.97,
    width: 14.84,
    height: 55.59
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 731.17,
    y: 112.97,
    width: 17.37,
    height: 55.59
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 707.08,
    y: 112.97,
    width: 19.9,
    height: 55.59
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 679.64,
    y: 51.57,
    width: 23.6,
    height: 13.77
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 688.59,
    y: 39,
    width: 5.71,
    height: 12.57
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 813.6,
    y: 112.97,
    width: 4.7,
    height: 55.59
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 802.18,
    y: 112.97,
    width: 7.24,
    height: 55.59
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 788.23,
    y: 112.97,
    width: 9.77,
    height: 55.59
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 771.74,
    y: 112.97,
    width: 12.3,
    height: 55.59
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 713.13,
    y1: 448.91,
    x2: 669.81,
    y2: 448.91
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 620.5,
    y: 403.85,
    width: 19.72,
    height: 2.19
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 620.5,
    y: 381.79,
    width: 19.72,
    height: 2.19
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 743.14,
    y: 403.94,
    width: 19.72,
    height: 2.19
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 743.14,
    y: 381.89,
    width: 19.72,
    height: 2.19
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "746.33 379.85 759.68 379.85 759.68 409.34 746.33 415.34 746.33 379.85"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "637.28 402.61 637.28 415.33 623.93 409.34 623.93 379.85 637.28 379.85 637.28 402.61"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M128.9,34C166.62,96.63,209.64,87,216.16,87.72"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M120.6,59.88c22.61,37.28,58.77,38.44,70.09,36"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M567.1,176.37v8.18a2.8,2.8,0,0,1-2.8,2.8H257.76a2.8,2.8,0,0,1-2.8-2.8V113.39a2.81,2.81,0,0,0-2.38-2.77c-7-1.05-27.63-5.58-36.42-22.9"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 165.22,
    y: 183.15,
    width: 73.8,
    height: 3.83,
    transform: "translate(404.25 370.13) rotate(-180)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 162.48,
    y: 186.98,
    width: 79.29,
    height: 16.3,
    transform: "translate(404.25 390.25) rotate(-180)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 223.3,
    cy: 178.48,
    r: 4.67
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 211.23,
    cy: 178.48,
    r: 4.67
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 193.21,
    cy: 178.48,
    r: 4.67
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 181.14,
    cy: 178.48,
    r: 4.67
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 180.97,
    y: 115.37,
    width: 42.15,
    height: 58.45,
    transform: "translate(404.08 289.18) rotate(-180)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 223.3,
    y: 165.1,
    width: 10.78,
    height: 4.07,
    transform: "translate(457.39 334.28) rotate(-180)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "223.12 161.81 234.09 161.81 234.09 132.95 223.12 115.95 223.12 161.81"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 170.17,
    y: 165.1,
    width: 10.78,
    height: 4.07
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "180.97 161.81 170.17 161.81 170.17 132.95 180.97 115.95 180.97 161.81"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 180.97,
    y: 111.08,
    width: 42.15,
    height: 4.28,
    transform: "translate(404.08 226.45) rotate(-180)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 214.55,
    y: 86.85,
    width: 1.8,
    height: 24.24,
    transform: "translate(430.89 197.93) rotate(-180)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 212.43,
    y: 88.88,
    width: 6.03,
    height: 15.28,
    rx: 3.02,
    transform: "translate(430.89 193.05) rotate(180)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 187.91,
    y: 95.41,
    width: 1.8,
    height: 15.38,
    transform: "translate(377.62 206.21) rotate(-180)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 185.79,
    y: 97.39,
    width: 6.03,
    height: 9.7,
    rx: 3.02,
    transform: "translate(377.62 204.47) rotate(-180)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 810.75,
    cy: 394.06,
    rx: 42.34,
    ry: 42.48
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M156.7,343.9l-.1.1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.3,67.2V214.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "68.64 238.4 68.64 323.86 57.51 323.86 57.51 146.03 68.64 146.03 68.64 238.4"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "92.54 238.4 92.54 323.86 81.4 323.86 81.4 146.03 92.54 146.03 92.54 238.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalfunctionsKaplanVertical);
export default __webpack_public_path__ + "static/media/malfunctions_kaplan-vertical.c5e7d451c022f1de0e9134155e262b4e.svg";
export { ForwardRef as ReactComponent };